import {Grid, Skeleton} from '@mui/material';
import React from 'react';

export const KanbanItemSkelotion = () => {
    return (
        <Grid container spacing={1} padding={1}>
            <Grid item xs={12}>
                <Skeleton variant="rectangular" width={'100%'} height={97} style={{borderRadius: '10px'}} />
            </Grid>
            <Grid item xs={12}>
                <Skeleton variant="rectangular" width={'100%'} height={97} style={{borderRadius: '10px'}} />
            </Grid>
            <Grid item xs={12}>
                <Skeleton variant="rectangular" width={'100%'} height={97} style={{borderRadius: '10px'}} />
            </Grid>
            <Grid item xs={12}>
                <Skeleton variant="rectangular" width={'100%'} height={97} style={{borderRadius: '10px'}} />
            </Grid>
            <Grid item xs={12}>
                <Skeleton variant="rectangular" width={'100%'} height={97} style={{borderRadius: '10px'}} />
            </Grid>
        </Grid>
    );
};

export default KanbanItemSkelotion;
